namespace Matrix.Rebalancer {
    export class HoldingWhitelistColumns {
        static columnsKey = 'Rebalancer.HoldingWhitelist';
    }
}
